import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import AuthenticateUser from "./components/authenticateuser";
import EmailVerification from "./components/emailverification";
import Forgot from "./components/forgot";
import Guess from "./components/guess";
import Home from "./components/home";
import InviteDraft from "./components/invitedraft";
import NotFound from "./components/notfound";
import { SignUP } from "./components/signup";
//export const server = "https://rokoserver.vercel.app/";
//for developing mode
export const server = "http://localhost:4000/";


window.global = window;
function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/invitedraft/:id" element={<InviteDraft />} />
          <Route path="guest" element={<Guess />} />
          <Route path="authorized" element={<AuthenticateUser />} />
          <Route path="signup" element={<SignUP />} />
          <Route path="emailverification" element={<EmailVerification />} />
          <Route path="forgotpassword" element={<Forgot />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
